"use client";

import * as React from "react";
import { Camera, Clock, Headset, Key } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Flexible Coverage",
  description: "Scalable staffing solutions tailored to your facility's specific surgical caseload and immediate requirements.",
  icon: Key
}, {
  title: "Qualified Professionals",
  description: "Vetted, high-caliber surgical specialists ready to integrate seamlessly into your clinical environment.",
  icon: Camera
}, {
  title: "Efficient Coordination",
  description: "Streamlined logistics and placement processes designed to minimize administrative overhead and downtime.",
  icon: Clock
}, {
  title: "Surgical-Focused Support",
  description: "Deep clinical understanding ensures we meet the highest standards of precision in surgical staffing.",
  icon: Headset
}];
export default function PremiumService() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="175486" id="whyatlas" ref={sectionRef} className="bg-background py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div className={`lg:col-span-5 flex flex-col items-start gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="space-y-6">
              <span className="text-sm font-bold tracking-widest text-accent-foreground uppercase">
                WHY ATLAS
              </span>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-semibold text-foreground leading-[1.1] tracking-tight">
                Why Atlas Surgical Partners
              </h2>
              <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed max-w-xl">
                We provide elite surgical staffing solutions that combine clinical excellence with enterprise-level efficiency. Partner with a team that understands the precision required in the operating room.
              </p>
            </div>
            
            <Button variant="default" size="lg" className="rounded-full px-8 py-6 text-base font-semibold shadow-md hover:shadow-lg transition-all duration-300 bg-gradient-to-r from-[#1E4FA3] to-[#0A2E6E] text-white hover:opacity-90" onClick={() => window.location.href = "/facilities/"}>
              Request Coverage
            </Button>
          </div>

          {}
          <div className={`lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6 transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {services.map((service, i) => <Card key={i} data-index={i} className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 group border-border/40 bg-card/80 backdrop-blur-sm transition-all duration-300 !shadow-[0px_4px_8px_rgba(20,21,31,0.18),_0px_2px_4px_rgba(20,21,31,0.13)] hover:shadow-md hover:-translate-y-1">
                <CardHeader className="pb-3">
                  <div className="size-12 rounded-xl bg-secondary/10 flex items-center justify-center mb-4 transition-colors duration-300 group-hover:bg-accent/20">
                    <service.icon className="size-6 text-secondary stroke-[1.5] group-hover:text-accent-foreground transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>)}
          </div>

        </div>
      </div>
    </section>;
}